import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { useCallbacks } from 'shared/hooks/utils';
import { loadUiGuideGroups, startUILearning } from 'console/ui-guide/redux/actions';
import { Alert, AlertTitle, List, Paper, Skeleton } from '@mui/material';
import { UiGuideListItem } from 'console/ui-guide/list/component';
import { useNavigateRoot } from 'shared/hooks/router';
export const UiLearningList = memo(function UiLearningList() {
    const ui_guide_statuses = useAppSelector((state) => new Map(state.account.ui_guide_statuses.map((status) => [
        status.group_id,
        status,
    ])));
    const ui_groups = useAppSelector((state) => state.ui_guide_state.available_ui_guide_groups);
    const { loading, error } = useAppSelector((state) => state.ui_guide_state.ui_guide_groups);
    const close = useNavigateRoot();
    const startLearning = useCallbacks([close, useAction(startUILearning)]);
    const loadUiLearning = useAction(loadUiGuideGroups);
    useEffect(() => {
        loadUiLearning();
    }, []);
    return (_jsx(Paper, { children: loading ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 50 })) : error ? (_jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0439" }), error] })) : (_jsx(List, { dense: true, children: ui_groups.map((group) => (_jsx(UiGuideListItem, { item: group, status: ui_guide_statuses.get(group.id), startLearning: startLearning }, group.id))) })) }));
});
